import * as constants from './constants';

const initialState = {
  orders: null,
  driver: null,
  submitting: {},
  modal: {
    open: false,
    order: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_ADJUST_ORDER_MODAL:
      return {
        ...state,
        modal: action.payload,
      };
    case constants.SET_ORDERS_DATA:
      return {
        ...state,
        orders: action.payload,
      };
    case constants.ADD_NEW_ORDER:
      return {
        ...state,
        orders: state.orders.concat(action.payload),
      };
    case constants.UPDATE_ORDER_STATUS:
      return {
        ...state,
        orders: state.orders.map((order) => {
          if (order.uuid === action.payload.uuid) {
            order.events.push(action.payload.event);
          }
          return order;
        }),
      };
    case constants.UPDATE_DELIVERY_DETAILS: {
      return {
        ...state,
        orders: state.orders.map((order) => {
          if (order.id === action.payload.orderId) {
            order.delivery = action.payload;
          }

          return order;
        }),
      }
    }
    case constants.SET_PARTNER:
      return {
        ...state,
        driver: action.payload,
      }
    case constants.SET_SUBMITTING_STATUS: {
      const { orderId, value } = action.payload;
      if (value) {
        return { ...state, submitting: { ...state.submitting, [orderId]: value } };
      }
      const next = { ...state.submitting };
      delete next[orderId];
      return { ...state, submitting: next };
    }
    default:
      return state;
  }
};

export default reducer;